import { useState } from "react";
import styles from "../../styles/Feedback.module.css";
import { addFeedback } from "../../lib/firebase/firestore"; // ✅ import Firestore helper

export const Feedback = () => {
  const [rating, setRating] = useState(0);
  const [review, setReview] = useState("");
  const [submitted, setSubmitted] = useState(false);
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    if (!rating || !review.trim()) return;

    try {
      setLoading(true);
      await addFeedback({ rating, review });
      setSubmitted(true);
      setRating(0);
      setReview("");
    } catch (error) {
      console.error("Error submitting feedback:", error);
      alert("Something went wrong. Please try again.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className={styles.container}>
      <h1 className={styles.title}>Feedback</h1>

      {!submitted ? (
        <form onSubmit={handleSubmit} className={styles.form}>
          <div className={styles.ratingGroup}>
            <label className={styles.label}>Address your suggestions for improvement:</label>
            <div className={styles.ratingButtons}>
              {[1, 2, 3, 4, 5].map((num) => (
                <button
                  key={num}
                  type="button"
                  onClick={() => setRating(num)}
                  className={`${styles.starButton} ${
                    rating >= num ? styles.active : ""
                  }`}
                >
                  ⭐
                </button>
              ))}
            </div>
          </div>

          <textarea
            placeholder="Write your idea here..."
            value={review}
            onChange={(e) => setReview(e.target.value)}
            className={styles.textarea}
            rows={4}
            required
          />

          <button
            type="submit"
            className={styles.submitButton}
            disabled={loading}
          >
            {loading ? "Submitting..." : "Submit Feedback"}
          </button>
        </form>
      ) : (
        <p className={styles.thankYou}>Thank you for your feedback!</p>
      )}
    </div>
  );
};
